import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Rates = () => {
    document.title = "Tariflər";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Tariflər", value: "/settings/rates", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Tariflər</h2>
                    <p>
                        Tariflər səhifəsində seçdiyimiz xidmətləri aktiv və ya deaktiv edib <SaveButton /> düyməsini sıxın.
                        <br />
                        <b>Qeyd</b>: Tarif dəyişildikdə gündəlik xidmət haqqı balansdan silinir.
                        <br />
                        Nümunədə istifadəçinin qoşulduğu tarif göstərilib.
                    </p>
                    <img src="/images/settings/rates.gif" alt="Tariflər" />
                </article>
            </div>
        </div>
    );
};
